import { IRoutesInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const routesSelector = (state: RootState) => state.routes;

const routesListSelector = createSelector([routesSelector], (routes: IRoutesInitialState) => routes.routesList);

const routeSelector = createSelector([routesSelector], (routes: IRoutesInitialState) => routes.route);

export const routesSel = {
    routesSelector,
    routeSelector,
    routesListSelector,
};
